import { FC } from 'react';
import { useTranslation } from '@packages/utils';
import { Modal } from 'components/Base/Modal';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { TRtkErrorType } from 'data/types/generic.types';
import ConfirmModalBody from 'components/Shared/ConfirmModalBody';
import { useReRegisterRegistrantMutation } from 'redux/apiSlice/registrants.slice';
import { TReregisterRegistrantModalProps } from './ReregisterRegistrantModal.types';

const ReregisterRegistrantModal: FC<TReregisterRegistrantModalProps> = ({
  open,
  setOpen,
  registrantId,
  workshopClassId,
  workshopId,
}) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.workshops.details.workshop-registrants.actions.reregister.modal',
  });
  const { showToastNotification } = useShowToastNotification();
  const [reRegisterRegistrant, { isLoading }] =
    useReRegisterRegistrantMutation();

  const handleSubmit = async () => {
    try {
      await reRegisterRegistrant({
        registrantId,
        workshopClassId,
        workshopId,
      }).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
      setOpen(false);
    } catch (e) {
      showToastNotification({
        message: (e as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Modal
      title={t('TITLE')}
      open={open}
      onCancel={() => setOpen(false)}
      onOk={handleSubmit}
      okText={t('REMOVE_BTN')}
      cancelText={t('CANCEL_BTN')}
      confirmLoading={isLoading}
    >
      <ConfirmModalBody title={t('SUBTITLE')} description={t('DESCRIPTION')} />
    </Modal>
  );
};

export default ReregisterRegistrantModal;
